import React, {useEffect} from 'react';
import './FernrauschApp.scss';
import PopupMenuView from '../popupmenu/PopupMenuView';
import {useModel} from '../../model/Model';
import {Breakpoint, getBreakpoint} from '../../utils/Breakpoint';
import {Events, EventType} from '../../events/Events';
import DesktopViewport from './DesktopViewport';
import MobileViewport from './MobileViewport';
import {ReadonlyContext} from '../context/ReadonlyContext';
import {TripContext} from '../context/TripContext';
import {UserContext} from '../context/UserContext';
import CopyToClipboardNotification from '../notification/CopyToClipboardNotification';
import {Appearance, AppearanceContext, getAppearance} from '../context/AppearanceContext';
import {Poi} from '../../react-app-env';
import {HoveringPoisContext} from '../context/HoveringPoisContext';

const FernrauschApp = () => {
  const [breakpoint, setBreakpoint] = React.useState<Breakpoint>();
  const [appearance, setAppearance] = React.useState<Appearance>();
  const [hoveringPois, setHoveringPois] = React.useState<Poi[]>();

  const model = useModel((model) => {
    console.info('Model is available', model);
  });

  const ready = model != null &&
                appearance != null &&
                breakpoint != null &&
                hoveringPois != null;

  useEffect(() => {
    setBreakpoint(getBreakpoint());
    setAppearance(getAppearance());
    setHoveringPois([]);

    Events.subscribe(EventType.BREAKPOINT_CHANGED, () => {
      setBreakpoint(getBreakpoint());
    });

    Events.subscribe(EventType.APPEARANCE_CHANGED, () => {
      setAppearance(getAppearance());
    });

    Events.subscribe(EventType.ON_POIS_HOVERING, (pois: Poi[]) => {
      setHoveringPois(pois);
    });
  }, []);

  function renderViewport(): React.ReactNode {
    if (!ready) {
      return null;
    }

    if (breakpoint === Breakpoint.PHONE) {
      return <MobileViewport googleMapsApiKey={model.googleMapsApiKey}/>;
    } else {
      return <DesktopViewport googleMapsApiKey={model.googleMapsApiKey}/>;
    }
  }

  return <React.Fragment>
    <header>
    </header>
    <main>
      <div id="breakpoint-detector"></div>
      <div id="appearance-detector"></div>
      {ready || (
          <div>Loading...</div>
      )}
      {ready && (
          <React.Fragment>
            <AppearanceContext value={appearance}>
              <ReadonlyContext value={model.readonly}>
                <TripContext value={model.trip}>
                  <UserContext value={model.user}>
                    <HoveringPoisContext value={hoveringPois}>
                      {renderViewport()}
                    </HoveringPoisContext>
                  </UserContext>
                </TripContext>
              </ReadonlyContext>
            </AppearanceContext>
            <PopupMenuView/>
            <CopyToClipboardNotification/>
          </React.Fragment>
      )}
    </main>
  </React.Fragment>;
};

export default FernrauschApp;
